import {setOrFallbackValue} from './helper';
export default class SupplierStock {
    constructor(props) {
        this.idSupplierStock = setOrFallbackValue(props, 'idSupplierStock', null);
        this.retailUnitPrice = setOrFallbackValue(props, 'retailUnitPrice', null);
        this.stockLocation = setStockLocation(props);
    }
}

function setStockLocation(props) {
    const stockLocation = setOrFallbackValue(props, 'stockLocation', '');
    if ('' === stockLocation) {
        return null;
    }

    const state = setOrFallbackValue(props.stockLocation, 'state', '');
    if ('' === state) {
        return {state: null};
    }

    return {state: stockLocation.state};
}

